import { Component } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';

import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
  FormArray,
} from '@angular/forms';
import {
  PAYMENT_MODES,
  PartnerTypesEnum,
  PaymentTypesEnum,
} from '../../../../helpers/helper-file';
// import { PaymentsItemService } from '../../../../features/payments/services/payments.service';
import { UploadFileService } from '../../../../shared/services/file-upload.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';
import { pymentGenerateNo } from '../../../../helpers/helper';
import { VendorInvoiceService } from '../../../../features/vendor-invoice/services/vendor-invoice.service';
import { PaymentMethodsEnum } from '../../../../../assets/enum/paymentMethodsEnum';
import { PaymentsService } from '../../../../features/payments/services/payments.service';
import { PreferenceCodeService } from '../../../../features/preference-code/services/preference-code.service';
// import { BankingService } from '../../../../features/banking/services/banking.service';
// import { PreferenceService } from '../../../../shared/services/preference.service';

@Component({
  selector: 'app-bill-payment',
  standalone: true,
  imports: [
    CommonModule,
    MatInputModule,
    MatSelectModule,
    MatDatepickerModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMatSelectSearchModule,
  ],
  templateUrl: './bill-payment.component.html',
  styleUrl: '../../bill-payment-new.component.scss',
})

//payment-made-new
export class BillPaymentComponent {
  billForm: FormGroup;
  vendorList: any;
  private partnerTypes = PartnerTypesEnum;
  private paymentType = PaymentTypesEnum;
  paymentModeList: any;
  getAccountList: any;
  partnerBillData: any;
  fullAmount: number = 0.0;
  documentFile: any = null;
  documentFileName: any = null;
  documentFileId: any = null;
  documentFileUrl: any = null;
  isLoading = false;
  vendorSearchControl = new FormControl();
  maxDate: Date = new Date();
  splitAmounts: number[] = []; // Array to store split values
  totalSplitAmount = 0; // Variable to store the total
  globalbillId: number;
  bankId: any;
  categoryId: any;
  paymentInfo: any[];
  billId: number;
  currentDate: Date = new Date();
  notesMap: { [key: number]: any } = {};
  branchId: number | null = null;
  private searchSubject = new Subject<string>();
  paymentNo: any;
  notes: any;
  balancesPayload: any;
  vendorId: any;
  constructor(
    private fb: FormBuilder,
    // private itemService: PaymentsItemService,
    private documentUploadService: UploadFileService,
    private datePipe: DatePipe,
    private toastr: ToastrService,
    private router: Router,
    private route: ActivatedRoute,
    private vendorInvoiceService: VendorInvoiceService,
    private itemService: PaymentsService,
    private preferenceService: PreferenceCodeService
  ) // private bankingService: BankingService,
  {
    this.initForm();
    this.fetchPartners();
    // this.fetchGetAccount();
    this.paymentInfo = [];
  }

  ngOnInit(): void {
    // this.branchId = Number(localStorage.getItem('selectedBranchId'));
    this.loadPaymentMethods();
    this.route.paramMap.subscribe((params) => {
      const id = params.get('id');
      if (id) {
        this.billId = +id;
        this.loadInvoiceData();
      }
    });

    this.searchSubject
      .pipe(debounceTime(600), distinctUntilChanged())
      .subscribe((searchTerm) => {
        this.fetchPartners(null, searchTerm);
      });

    // this.vendorSearchControl.valueChanges
    //   .pipe(debounceTime(300), distinctUntilChanged())
    //   .subscribe((searchText) => {
    //     this.fetchPartners(null,searchText);
    //   });

    // Recalculate splits and total whenever amountReceived changes

    // Initial calculation
    // this.calculateSplits();

    //calculateExcessAmount
    this.billForm.get('paymentMade')?.valueChanges.subscribe(() => {
      this.calculateExcessAmount();
      this.usedAmount();
    });
    if(!this.billId){
      this.preferenceCode();
    }
  }

  initForm(): void {
    this.billForm = this.fb.group({
      // id: [''],
      vendorName: ['', Validators.required],
      payment: ['', Validators.required],
      paymentMade: ['', Validators.required],
      paymentDate: ['', Validators.required],
      paymentMode: ['', Validators.required],
      depositTo: [''],
      reference: [''],
      chequeNo: [''],
      chequeDate: [''],
      note: [''],
      isFullAmount: [false],
    });

    this.billForm.get('paymentMode')?.valueChanges.subscribe((mode) => {
      const chequeNoControl = this.billForm.get('chequeNo');
      const chequeDateControl = this.billForm.get('chequeDate');
      const depositTo = this.billForm.get('depositTo');

      if (mode === 'Cheque') {
        chequeNoControl?.setValidators([Validators.required]);
        chequeDateControl?.setValidators([Validators.required]);
      } else if (mode === 'Bank' && mode === 'CreditCard') {
        depositTo?.setValidators([Validators.required]);
      } else {
        depositTo?.clearValidators();
        chequeNoControl?.clearValidators();
        chequeDateControl?.clearValidators();
      }

      chequeNoControl?.updateValueAndValidity();
      chequeDateControl?.updateValueAndValidity();
    });
  }

  preferenceCode(search: string = '') {
    this.preferenceService.fetchPreferenceCodes(search, 'Payment Made').subscribe({
      next: (response: any) => {
        response.forEach((prefix: any) => {
          this.paymentNo = prefix?.sequenceCode;
        })
        this.billForm.patchValue({ payment: this.paymentNo });
      },
      error: (error: any) => {
        console.error(error, 'Error');
      },
    });
  }

  onVendorSearch(event: Event) {
    const input = event.target as HTMLInputElement;
    const searchTerm = input.value;
    this.searchSubject.next(searchTerm);
  }

  private loadInvoiceData(): void {
    // const id = this.billForm.get('id')?.value;
    if (this.billId) {
      this.itemService.payment(this.billId).subscribe({
        next: (data) => {
          this.vendorId = data.vendorId;
          if (this.vendorId) {
            this.getDueBillsByPartner(this.vendorId);
          }
          // this.getDueBillsByPartner(data?.partnerId);
          console.log('data', data);
          if (data.paymentMethod == 'Bank') {
            this.fetchbanks();
          } else if (data.paymentMethod == 'CreditCard') {
            this.fetchCreditCard();
          }
          this.paymentInfo = data.paymentInfo;
          // this.documentFileName = data?.paymentAttachments?.[0]?.fileName;
          // this.documentFileId = data?.paymentAttachments?.[0]?.id;
          // this.documentFileUrl = data?.paymentAttachments?.[0]?.fileUrl;
          // this.fetchPartners( data?.partnerId);
          this.billForm.patchValue({
            // id: data?.id,
            vendorName: data?.vendorId,
            paymentDate: data?.paymentDate ? new Date(data?.paymentDate) : null, //Date
            paymentMade: parseFloat(data?.amount),
            paymentType: data?.paymentType,
            paymentMode: data.paymentMethod,
            depositTo:
              data.paymentMethod == 'Bank'
                ? data.bankAccountId
                : data.paymentMethod == 'CreditCard'
                ? data.creditCardId
                : null,
            payment: data.paymentCode,
            reference: data.referenceNo,
            chequeNo: data.chequeNo,
            chequeDate: data.chequeDate,
            // paymentMade: data.totalAmount,
            note: data?.notes,
          });
          // this.calculatePriority(data?.amount);
        },
        error: (error) => console.error(error),
      });
    }
  }

  private fetchPartners(id: number | null = null, search: string = '') {
    this.vendorInvoiceService.fetchVendors(search).subscribe({
      next: (data) => {
        // console.log(data);
        this.vendorList = data;
      },
      error: (err) => {
        console.log(err);
      },
    });
  }
  private fetchGetAccount() {
    // this.itemService.fetchDepositTo('', false, true)?.subscribe({
    //   next: (getAccount: any) => {
    //     this.getAccountList = getAccount;
    //   },
    //   error: (error: any) => console.error(error),
    // });
  }

  private loadPaymentMethods() {
    this.paymentModeList = Object.values(PaymentMethodsEnum).map((type) => ({
      label: type.label,
      value: type.value,
    }));
  }

  private getDueBillsByPartner(id: number) {
    this.itemService.fetchOpenOrPartiallyPaidBills(id).subscribe({
      next: (invoiceData: any) => {
        this.partnerBillData = invoiceData;
        console.log('this.partnerBillData', this.partnerBillData);

        this.fullAmount = this.partnerBillData?.reduce(
          (total: number, item: { balance: number }) => total + item.balance,
          0
        );
        if (this.billId) {
          this.partnerBillData.forEach((bill: any) => {
            this.splitAmounts[bill.id] = 0;
          });

          // Update splitAmounts with paymentInfo amounts
          this.paymentInfo.forEach((payment) => {
            if (this.splitAmounts.hasOwnProperty(Number(payment.refId))) {
              this.splitAmounts[payment.refId] = payment.amount;
              this.totalSplitAmount += payment.amount;
            }
          });
          console.log('this.splitAmounts', this.splitAmounts);

        }
      },
      error: (error: any) => console.error(error),
    });
    // this.itemService.getDueBillsByPartner(id, {})?.subscribe({
    //   next: (invoiceData: any) => {
    //     if (this.globalbillId) {
    //       this.partnerBillData = invoiceData.filter(
    //         (item: any) => item.id === this.globalbillId
    //       );
    //     } else {
    //       this.partnerBillData = invoiceData;
    //     }
    //     this.calculateSplits(false);

    //     if(this.billId) {
    //       this.partnerBillData.forEach((bill: any) => {
    //         this.splitAmounts[bill.id] = 0;
    //       });

    //       // Update splitAmounts with paymentInfo amounts
    //       this.paymentInfo.forEach((payment) => {
    //         if (this.splitAmounts.hasOwnProperty(payment.refId)) {
    //           this.splitAmounts[payment.refId] = payment.amount;
    //           this.totalSplitAmount += payment.amount;
    //         }
    //       });
    //     }

    //     this.notesBasedOnRefId(invoiceData.map((item: any) => item?.id));
    //   },
    //   error: (error: any) => console.error(error),
    // });
  }

  notesBasedOnRefId(ids: any[]) {
    // this.itemService.notesBasedOnRefId(ids, 'Bill').subscribe({
    //   next: (data: any) => {
    //     this.notes = data;
    //     this.notesMap = this.notes.reduce((map: any, note: any) => {
    //       map[note?.refId] = note;
    //       return map;
    //     }, {});
    //     this.balancesPayload = {
    //       balances: Object.values(this.notesMap)
    //         .flatMap((entry: any) =>
    //           entry?.notes?.map((note: any) => ({
    //             noteId: note.id,
    //             amountUsed: note.balance,
    //           })) || []
    //         )
    //     };
    //   },
    //   error: (error: any) => this.toastr.error(error, 'Error')
    // })
  }

  onAmountChange(value: number, index: number) {
    this.totalSplitAmount = this.splitAmounts.reduce(
      (acc, curr) => +acc + +curr,
      0
    );
    this.billForm
      .get('paymentMade')
      ?.setValue(this.totalSplitAmount.toFixed(2));
  }

  onCheckboxChange(event: Event, billId: any, balance: number): void {
    const isChecked = (event.target as HTMLInputElement).checked;

    if (isChecked) {
      this.splitAmounts[billId] = balance; // set due amount
    } else {
      this.splitAmounts[billId] = 0; // or delete this.splitAmounts[billId];
    }

    this.calculateTotalSplitAmount();
    this.billForm
      .get('paymentMade')
      ?.setValue(this.totalSplitAmount.toFixed(2));
  }

  calculateTotalSplitAmount() {
    this.totalSplitAmount = Object.values(this.splitAmounts).reduce(
      (sum, val) => sum + (parseFloat(val as any) || 0),
      0
    );
  }

  onInput(index: number, event: any, balance: number): void {
    const inputValue = parseFloat(event.target.value);
    if (inputValue > balance) {
      event.target.value = balance; // Set the input value to the balance
      this.splitAmounts[index] = balance; // Update the model
    }
    // this.totalSplitAmount = this.splitAmounts.reduce((acc, curr) => +acc + +curr, 0);
    this.calculateTotalSplitAmount();
    this.billForm
      .get('paymentMade')
      ?.setValue(this.totalSplitAmount.toFixed(2));
  }

  calculateSplits(isFullAmount: boolean): void {
    this.partnerBillData.forEach((item: any, index: number) => {
      if (isFullAmount) {
        this.splitAmounts[item?.id] = item.balance;
      } else {
        this.splitAmounts[item?.id] = 0;
      }
    });

    // const amountReceived = this.billForm.get('paymentMade')?.value || 0;
    // const totalEntries = this.partnerBillData?.length;
    // const splitAmount = totalEntries > 0 ? amountReceived / totalEntries : 0;

    // // Populate the splitAmounts array
    // this.splitAmounts = Array(totalEntries).fill(splitAmount);

    // // Calculate the total of split amounts
    // this.totalSplitAmount = this.splitAmounts.reduce(
    //   (acc, curr) => acc + curr,
    //   0
    // );
  }

  onCustomerSelected(event: MatSelectChange) {
    const selectedCustomerId = event.value;
    this.billForm.get('paymentMade')?.setValue('');
    this.billForm.get('isFullAmount')?.setValue(false);
    this.getDueBillsByPartner(selectedCustomerId);
  }

  // onFileSelected(event: Event): void {
  //   const input = event.target as HTMLInputElement;
  //   if (input.files && input.files.length > 0) {
  //     const file = input.files[0];
  //     this.documentFileName = file.name;
  //     this.documentFile = file;
  //   }
  // }

  // onFileSelected(event: Event): void {
  //   const input = event.target as HTMLInputElement;
  //   if (input.files && input.files.length > 0) {
  //     const file = input.files[0];

  //     // Allowed file types (MIME types)
  //     const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/gif', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];

  //     // Check if the file type is allowed
  //     if (allowedTypes.includes(file.type)) {
  //       this.documentFileName = file.name;
  //       this.documentFile = file;
  //     } else {
  //       // File type is not allowed, reset the input and show an error message
  //       this.documentFileName = undefined;
  //       this.documentFile = undefined;
  //       this.toastr.error('Cant upload this file');

  //       // Reset the file input field
  //       const fileInput = document.querySelector('input[type="file"]') as HTMLInputElement;
  //       if (fileInput) {
  //         fileInput.value = ''; // Clears the file input field
  //       }
  //     }
  //   }
  // }

  toggleFullAmount(event: Event): void {
    const checkbox = event.target as HTMLInputElement;
    if (checkbox.checked) {
      this.billForm.get('paymentMade')?.setValue(this.fullAmount.toFixed(2));
      this.calculateSplits(true);
      this.totalSplitAmount = this.fullAmount;
    } else {
      this.billForm.get('paymentMade')?.setValue('');
      this.calculateSplits(false);
      this.totalSplitAmount = 0;
    }
  }

  onPaymentMadeChange(event: Event): void {
    const inputValue = (event.target as HTMLInputElement).value;
    if (this.fullAmount < parseFloat(inputValue)) {
      this.billForm.get('paymentMade')?.setValue(this.fullAmount.toFixed(2));
      this.calculatePriority(this.fullAmount);
      this.toastr.warning('Cant exceed full amount');
    } else {
      this.calculatePriority(+inputValue);
    }
  }

  onPaymentModeChange(event: MatSelectChange) {
    const selectedMode = event.value;
    if (selectedMode === 'Bank') {
      this.fetchbanks();
    } else if (selectedMode === 'CreditCard') {
      this.fetchCreditCard();
    }
  }

  fetchbanks() {
    this.itemService.bankAccounts('', this.branchId).subscribe({
      next: (res: any) => {
        if (res) {
          this.getAccountList = res;
          console.log('bankdata', this.getAccountList);
        }
      },
      error: (error: any) => {
        console.error('Error fetching bank accounts:', error);
        this.toastr.error('Failed to fetch bank accounts', 'Error');
      },
    });
  }

  fetchCreditCard() {
    this.itemService.creditCards('', this.branchId).subscribe({
      next: (res: any) => {
        if (res) {
          this.getAccountList = res;
          console.log('creditcard', this.getAccountList);
        }
      },
      error: (error: any) => {
        console.error('Error fetching credit cards:', error);
        this.toastr.error('Failed to fetch credit cards', 'Error');
      },
    });
  }

  calculatePriority(amount: number) {
    this.partnerBillData.forEach((item: any, index: number) => {
      if (amount > 0) {
        if (amount >= item.balance) {
          this.splitAmounts[item?.id] = item.balance;
          amount = amount - this.splitAmounts[item?.id];
        } else {
          this.splitAmounts[item?.id] = +amount.toFixed(2);
          amount = 0;
        }
      } else {
        this.splitAmounts[item?.id] = 0;
      }
    });
    this.totalSplitAmount = this.splitAmounts.reduce(
      (acc, curr) => +acc + +curr,
      0
    );
  }

  calculateExcessAmount(): number {
    const amountReceived = this.billForm.get('paymentMade')?.value || 0;
    return this.fullAmount - amountReceived;
  }

  updateNoteBalances() {
    // this.itemService.updateNoteBalances(this.balancesPayload).subscribe({
    //   next: (res: any) => {
    //     if(res){
    //       this.toastr.success('Note balance updated successfully.');
    //     }
    //   },
    //   error: (err: any) => {
    //     this.toastr.error('Error updating note balance.');
    //   },
    // })
  }

  usedAmount(): number {
    const amountReceived = this.billForm.get('paymentMade')?.value || 0;
    return amountReceived;
  }

  clearDocument() {
    this.documentFile = null;
    this.documentFileName = null;
  }

  onCreate(): void {
    if (this.billForm.invalid) {
      this.billForm.markAllAsTouched();
      return;
    }
    this.isLoading = true;
    // this.documentUploadService
    //   .uploadDocument(this.documentFile, 'payment-received')
    //   .subscribe({
    //     next: (url) => {
    //       if (url) {
    //         this.documentFileUrl = url?.url;
    //       }
    const data = this.billForm.value;

    let billIds: any = [];

    this.partnerBillData.forEach((item: any, index: number) => {
      if (
        this.splitAmounts[item?.id] > 0 ||
        this.notesMap[item?.id]?.totalBalance > 0
      ) {
        billIds.push({
          billId: item?.id,
          amount: +this.splitAmounts[item?.id],
          // "noteAmount": this.notesMap[item?.id]?.totalBalance,
        });
      }
    });
    let paymentPayload: any = {
      vendorId: data.vendorName,
      paymentDate: this.datePipe.transform(data.paymentDate, 'yyyy/MM/dd'),
      amount: parseFloat(data.paymentMade) ?? 0,
      paymentType: this.paymentType.BILL,
      paymentMethod: data.paymentMode,
      paymentCode: data.payment,
      referenceNo: data.reference,
      notes: data.note,
      paymentStatus: 'Pending',
    };

    // Add relevant ID depending on the mode
    if (data.paymentMode === 'Bank') {
      paymentPayload.bankAccountId = data.depositTo;
    }
    if (data.paymentMode === 'CreditCard') {
      paymentPayload.creditCardId = data.depositTo;
    }
    if (data.paymentMode === 'Cheque') {
      paymentPayload.isCheque = true;
      paymentPayload.chequeNo = data.chequeNo;
      paymentPayload.chequeDate = data.chequeDate
        ? this.datePipe.transform(data.chequeDate, 'yyyy/MM/dd')
        : null;
    }

    const billIDAmountInput = billIds;
    this.isLoading = true;

    const invoiceIDAmountInput: any = null;

    if (this.billId) {
      // updateing
      // const itemInputUpdateData = {
      //   id: data?.id,
      //   ...paymentPayload,
      // };

      // const createPaymentUpdateAttachment = {
      //   id: this.documentFileId ?? null,
      //   ...createPaymentAttachment,
      // };

      this.itemService
        .updatePayment(
          this.billId,
          paymentPayload,
          invoiceIDAmountInput,
          billIDAmountInput
        )
        .subscribe({
          next: () => {
            // this.isLoading = false;
            // this.generatePDF(data?.id, 'Bill');
            this.toastr.success('Payment made updated successfully.');
            // this.updateNoteBalances();
            // if (this.bankId) {
            //   this.createTransaction(data?.id);
            // } else {
            setTimeout(() => {
              this.router.navigate(['/payments-made']);
            }, 1000);
            // }
          },
          error: (error: Error) => {
            // this.isLoading = false;
            this.toastr.error(error.message || 'Failed to update item.');
          },
        });
    } else {
      this.itemService
        .createPayments(paymentPayload, invoiceIDAmountInput, billIDAmountInput)
        .subscribe({
          next: (data: any) => {
            this.isLoading = false;
            // this.generatePDF(data?.data?.createPayment?.id, 'Bill');
            this.toastr.success('Payment made Created successfully.');
            // if (this.bankId) {
            // this.updateNoteBalances();
            // this.createTransaction(data?.data?.createPayment?.id);

            // } else {
            setTimeout(() => {
              this.router.navigate(['/payments-made']);
            }, 1000);
            // }
          },
          error: (error) => {
            this.isLoading = false;
            this.toastr.error(error.message || 'Failed to update item.');
          },
        });
    }
    //   },
    //   error: (error) => {
    //     this.isLoading = false;
    //     this.toastr.error('upload failed', error);
    //   },
    // });
  }

  generatePDF(id: number, type: string) {
    // this.itemService.generatePaymentPdf(id, type).subscribe({
    //   next: () => {},
    //   error: (error: any) =>
    //     console.error('Error fetching employee types:', error),
    // });
  }

  createTransaction(id: any) {
    const transactionData = {
      date: this.datePipe.transform(
        this.billForm.value.paymentDate,
        'yyyy-MM-dd'
      ),
      transactionStatus: 'Manual',
      referenceNumber: this.billForm.value.payment,
      chequeNumber: this.billForm.value.chequeNo,
      amount: Number(this.billForm.value.paymentMade),
      paidVia: this.billForm.value.paymentMode,
      description: this.billForm.value.note,
      flow: 'Debit',
      refTableType: 'Payment',
      refId: id,
      offsetAccountId: this.bankId
        ? Number(this.bankId)
        : this.billForm.value.depositTo,
      transactionCategoryId: Number(this.categoryId),
    };

    // this.bankingService.createTransaction(transactionData).subscribe({
    //   next: (data) => {
    //     if(this.bankId){
    //       this.router.navigate([`/banking/banking-details/${this.bankId}`]);
    //     } else {
    //       return;
    //     }
    //   },
    //   error: (error) => {
    //     this.toastr.error(error, 'Error');
    //   }
    // })
  }

  isDueDatePast(dueDate: string | null | undefined): boolean {
    if (!dueDate) {
      return false;
    }
    const due = new Date(Number(dueDate));
    return due < this.currentDate;
  }
}
